import React, { useEffect } from "react";
import { Table  } from 'antd';
import { connect } from "react-redux";
import { 
    getTrainingModuleResultList, doTrainingModuleResultDelete
} from "../../../../../redux/trainingclass/trainingClassState";
import { handleTableChange } from "utils";
import Card from "components/card";

// import CrudOption from "components/dropdown/crudoption";
// import PopupButton from "components/button/PopupButton";
// import TrainingModuleResultForm from "./TrainingModuleResultForm";


const TrainingModuleResultTable = ({ recordList, pagination, doSearch, filters, doDelete, classeId }) => {

    const columns = [
		{
	        title: `Module Title`,
	        dataIndex: 'module_name',
	        key: 'module_name',
	        width: '55%',
	        render:(module_name) => <span>{module_name}</span> 
	    },
        {
	        title: `Participant Name`,
	        dataIndex: 'participant_name',
	        key: 'participant_name',
	        width: '30%',
	        render:(participant_name) => <span>{participant_name}</span> 
	    },
        {
	        title: `Final Score`,
	        dataIndex: 'trs_score',
	        key: 'trs_score',
	        width: '15%',
	        render:(trs_score) => <span>{trs_score}</span> 
	    },

        // {
	    //     title: <PopupButton id="add_results" title="Add Results" label="Add" btnClass="btn-small">
		// 				<TrainingModuleResultForm recordId={0} mode="edit" classeId={classeId} />
		// 			</PopupButton>,
	    //     dataIndex: 'trs_id',
	    //     key: 'trs_id',
	    //     width: '12%',
	    //     render:(_, record) => <CrudOption 
        //                             baseRoute={`/console/training-module-classes/${classeId}/training-module-results`} 
        //                             recordId={record?.trs_id} 
        //                             allowEdit={false}
        //                             deleteHandler={() => doDelete({
        //                                 trs_class_id: record?.trs_class_id,
        //                                 trs_id: record?.trs_id,
        //                             })} 
        //                         />
	    // },
    ]   
	
    
    useEffect(() => {
        if (classeId) {
            doSearch({paginate: pagination.per_page, classeId});
        } 
    }, [doSearch, classeId]);

    return (   
        <Card extra={"w-full h-full"}>
            <div className="h-full overflow-x-scroll xl:overflow-x-hidden">
                <Table
                    dataSource={recordList} 
                    columns={columns} 
                    rowKey={(record) => record.trs_id}
                    pagination={{...pagination, 
                        showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,}}    
                    onChange={handleTableChange(doSearch, filters)}                  	
                />
            </div>
        </Card>
    );
};

const mapStateToProps = (state) => ({
    recordList: state.trainingClass.trainingModuleResultList?.items,
    pagination: state.trainingClass.trainingModuleResultList?.pagination,
    filters: state.trainingClass.trainingModuleResultList?.filters,
    requesting: state.trainingClass.trainingModuleResultList?.requesting,
    error: state.trainingClass.trainingModuleResultList?.error,
});

const mapDispatchToProps = (dispatch) => ({
    doSearch: (filters) => dispatch(getTrainingModuleResultList(filters)),
    doDelete: (id) => dispatch(doTrainingModuleResultDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleResultTable);
